document.addEventListener("DOMContentLoaded", function () {
  const brandSelect = document.getElementById("car_maker_select");
  const modelSelect = document.getElementById("model_select");
  const searchButton = document.getElementById("search_button");

  if (!brandSelect || !modelSelect || !searchButton) return;

  const defaultBrandOptionText = document.querySelector('#car_maker_select option').textContent;
  const defaultModelOptionText = document.querySelector('#model_select option').textContent;

  const brandCollections = {
   "ALFA ROMEO": "alfa-romeo",
  "AUDI": "audi",
  "BMW": "bmw",
  "CHEVROLET": "chevrolet",
  "CITROEN": "citroen",
  "DACIA": "dacia",
  "DAF": "daf",
  "FIAT": "fiat",
  "FORD": "ford",
  "HONDA": "honda",
  "HYUNDAI": "hyundai",
  "IVECO": "iveco",
  "JAGUAR": "jaguar",
  "JEEP": "jeep",
  "KIA": "kia",
  "LAND ROVER": "land-rover",
  "LEXUS": "lexus",
  "MAN": "man",
  "MAZDA": "mazda",
  "MERCEDES-BENZ": "mercedes-benz",
  "MINI": "mini",
  "MITSUBISHI": "mitsubishi",
  "NISSAN": "nissan",
  "OPEL": "opel",
  "PEUGEOT": "peugeot",
  "PORSCHE": "porsche",
  "RENAULT": "renault",
  "RENAULT TRUCKS": "renault-trucks",
  "SCANIA": "scania",
  "SEAT": "seat",
  "SKODA": "skoda",
  "SMART": "smart",
  "SUBARU": "subaru",
  "SUZUKI": "suzuki",
  "TOYOTA": "toyota",
  "VOLKSWAGEN": "volkswagen",
  "VOLVO": "volvo"
  };

  

  brandSelect.innerHTML = `<option value="">${defaultBrandOptionText}</option>`;
  Object.keys(brandCollections).forEach((brand) => {
    const option = document.createElement("option");
    option.value = brand;
    option.textContent = brand;
    brandSelect.appendChild(option);
  });

  brandSelect.addEventListener("change", async function () {
    const selectedBrand = this.value;
    modelSelect.innerHTML = `<option value="">${defaultModelOptionText}</option>`;
    if (!selectedBrand) return;

    const handle = brandCollections[selectedBrand];
    const endpoint = "https://misterspareparts.com/api/2023-07/graphql.json";
    const token = "e6e733615e0bcc651533935a5f6ebe93";

    const query = `
      query GetProductsByCollection($handle: String!) {
        collectionByHandle(handle: $handle) {
          products(first: 250) {
            edges {
              node {
                metafields(identifiers: [{namespace: "custom", key: "left_filter_model"}]) {
                  value
                }
              }
            }
          }
        }
      }
    `;

    const variables = { handle };

    try {
      const res = await fetch(endpoint, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Shopify-Storefront-Access-Token": token,
        },
        body: JSON.stringify({ query, variables }),
      });

      const json = await res.json();
      const edges = json?.data?.collectionByHandle?.products?.edges || [];
      const models = new Set();

      edges.forEach(({ node }) => {
        const metafieldVal = node.metafields?.[0]?.value;
        if (metafieldVal) {
          metafieldVal.split(",").forEach((m) => {
            const trimmed = m.trim();
            if (trimmed) models.add(trimmed);
          });
        }
      });

      if (models.size === 0) {
        const option = document.createElement("option");
        option.value = "";
        option.textContent = "Nessun modello trovato";
        option.disabled = true;
        option.hidden = true;
        modelSelect.appendChild(option);
        return;
      }

      models.forEach((model) => {
        const option = document.createElement("option");
        option.value = model;
        option.textContent = model;
        modelSelect.appendChild(option);
      });
    } catch {
      const option = document.createElement("option");
      option.value = "";
      option.textContent = "Errore nel recupero dei modelli";
      option.disabled = true;
      option.hidden = true;
      modelSelect.appendChild(option);
    }
  });

  searchButton.addEventListener("click", function () {
    const selectedBrand = brandSelect.value;
    const selectedModel = modelSelect.value;

    const baseURL = "https://misterspareparts.com/a/search/all-products";
    const params = [];

    if (selectedBrand) params.push(`filter_marca_dell_auto=${encodeURIComponent(selectedBrand)}`);
    if (selectedModel) params.push(`filter_modelli=${encodeURIComponent(selectedModel)}`);

    const finalURL = baseURL + (params.length ? "?" + params.join("&") : "");
    window.location.href = finalURL;
  });
});
